export default "__VITE_ASSET__rpz0Lm1T__"